import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Flex } from '@modusign/design-system';

import {
  participantOrder1,
  participantOrder2,
  participantOrder3,
  participantOrder4,
  participantOrder5,
  participantOrder6,
  participantOrder7,
  participantOrder8,
  participantOrder9,
  participantOrder10,
} from '@app/theme/colors';

const signerColors: string[] = [
  participantOrder1,
  participantOrder2,
  participantOrder3,
  participantOrder4,
  participantOrder5,
  participantOrder6,
  participantOrder7,
  participantOrder8,
  participantOrder9,
  participantOrder10,
];

interface SignerFieldFontAwesomeIconProps {
  order: number;
  icon: IconProp;
}

export default function SignerFieldFontAwesomeIcon({
  order,
  icon,
}: SignerFieldFontAwesomeIconProps) {
  const orderValue = Math.max(Number.isInteger(order) ? order : 1, 1);
  return (
    <Box as="span" color={signerColors[(orderValue - 1) % signerColors.length]} fontSize={18}>
      <Flex alignItems="center" justifyContent="center">
        <FontAwesomeIcon icon={icon} />
      </Flex>
    </Box>
  );
}
